import { useMemo } from "react"
import { useTranslation } from "react-i18next"
import classNames from "classnames"

import AddToAppleWalletEn from "./assets/add_to_apple_wallet_en.svg"
import AddToAppleWalletFr from "./assets/add_to_apple_wallet_fr.svg"
import AddToAppleWalletDe from "./assets/add_to_apple_wallet_de.svg"
import AddToAppleWalletGr from "./assets/add_to_apple_wallet_gr.svg"
import AddToAppleWalletIt from "./assets/add_to_apple_wallet_it.svg"
import AddToAppleWalletPt from "./assets/add_to_apple_wallet_pt.svg"
import AddToAppleWalletRu from "./assets/add_to_apple_wallet_ru.svg"
import AddToAppleWalletEs from "./assets/add_to_apple_wallet_es.svg"

import AddToGoogleWalletEn from "./assets/add_to_google_wallet_en.svg"
import AddToGoogleWalletFr from "./assets/add_to_google_wallet_fr.svg"
import AddToGoogleWalletDe from "./assets/add_to_google_wallet_de.svg"
import AddToGoogleWalletGr from "./assets/add_to_google_wallet_gr.svg"
import AddToGoogleWalletIt from "./assets/add_to_google_wallet_it.svg"
import AddToGoogleWalletPt from "./assets/add_to_google_wallet_pt.svg"
import AddToGoogleWalletRu from "./assets/add_to_google_wallet_ru.svg"
import AddToGoogleWalletEs from "./assets/add_to_apple_wallet_es.svg"

export const addToAppleWalletByLanguage: any = {
  en: AddToAppleWalletEn,
  fr: AddToAppleWalletFr,
  de: AddToAppleWalletDe,
  gr: AddToAppleWalletGr,
  it: AddToAppleWalletIt,
  pt: AddToAppleWalletPt,
  ru: AddToAppleWalletRu,
  es: AddToAppleWalletEs,
}

export const addToGoogleWalletByLanguage: any = {
  en: AddToGoogleWalletEn,
  fr: AddToGoogleWalletFr,
  de: AddToGoogleWalletDe,
  gr: AddToGoogleWalletGr,
  it: AddToGoogleWalletIt,
  pt: AddToGoogleWalletPt,
  ru: AddToGoogleWalletRu,
  es: AddToGoogleWalletEs,
}

export type GiftCardWalletLinksProps = {
    appleWalletLink?: string;
    googleWalletLink?: string;
}

export const GiftCardWalletLinks = ({ appleWalletLink, googleWalletLink }: GiftCardWalletLinksProps) => {
    const { i18n } = useTranslation("gift_card")

    const userAgent = navigator.userAgent || navigator.vendor

    const isIOS = useMemo(() => /iPad|iPhone/.test(userAgent), [ userAgent ])
    const isAndroid = useMemo(() => /Android/.test(userAgent), [ userAgent ])

    return (
      <div className="flex justify-center gap-3.75 mx-auto mb-4 lg:px-11">
        {((!isIOS && !isAndroid) || isIOS) && (
          <a className={classNames({ "relative after:content-[''] after:absolute after:top-0 after:bottom-0 after:left-0 after:right-0 after:bg-[#FFFFFF]/50": !appleWalletLink })}
            href={appleWalletLink ? `${appleWalletLink}?v=${Date.now()}` : "/"}
            download
            title=""
            onClick={(event) => {
              if (!appleWalletLink) {
                event.preventDefault();
              }
            }}
          >
            <img
              src={addToAppleWalletByLanguage[i18n.language] || AddToAppleWalletEn}
              alt=""
              style={{
                width: "auto",
                height: "55px",
              }}
            />
          </a>
        )}
        {((!isIOS && !isAndroid) || isAndroid) && (
          <a className={classNames({ "relative after:content-[''] after:absolute after:top-0 after:bottom-0 after:left-0 after:right-0 after:bg-[#FFFFFF]/50": !googleWalletLink })}
            target="_blank"
            href={googleWalletLink ? `${googleWalletLink}?v=${Date.now()}` : "/"}
            download
            title=""
            onClick={(event) => {
              if (!appleWalletLink) {
                event.preventDefault();
              }
            }}
          >
            <img className="w-auto! h-12.75!"
              src={addToGoogleWalletByLanguage[i18n.language] || AddToGoogleWalletEn}
              alt=""
              style={{
                width: "auto",
                height: "51px",
              }}
            />
          </a>
        )}
      </div>
    )
}